<template>
  <v-container>
    <DynamicForm
      form="academic_procedure_form"
      title="Create Academic Procedure"
      :initialData="initialData"
      :handleSubmit="handleSubmit"
      cancelLink="academicProcedures"
    ></DynamicForm>
  </v-container>
</template>

<script>
import DynamicForm from "@/components/forms/DynamicForm.component.vue";
import academicProceduresService from "@/services/academic-procedures-service";

export default {
  name: "CreateAcademicYearView",
  components: { DynamicForm },
  data() {
    return {
      initialData: {
        Procedure: {},
      },
    };
  },
  methods: {
    handleSubmit(payload) {
      academicProceduresService
        .createAcademicProcedure({ ...payload, id: this.$route.params.id })
        .then(() => {
          this.$router.push({ name: "academicProcedures" });
        });
    },
  },
};
</script>
